export const AboutPage = () => (
  <div className="pt-32 sm:pt-28 md:pt-24 lg:pt-20">
    <div className="py-20" style={{ backgroundColor: "#fafaee" }}>
      <div className="container mx-auto px-4 max-w-4xl text-center">
        <h1 className="text-4xl font-bold mb-8" style={{ color: "#163233" }}>
          About Tushti IAS
        </h1>
        <p className="text-lg text-gray-700 mb-6">
          With over 7 years of experience in competitive exam preparation,
          Tushti IAS has been the cornerstone of success for
          thousands of students across Gujarat and India.
        </p>
        <p className="text-lg text-gray-700 mb-8">
          Our expert faculty, comprehensive study materials, and proven
          methodologies ensure that every student receives personalized
          attention and achieves their career goals.
        </p>
      </div>
    </div>
  </div>
);
